export default "<button type=\"submit\" class=\"button\" [disabled]=\"disable\" [id]=\"id\" (click)=\"buttonClicked()\" >{{text}}</button>\r\n";